var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { filterSnackById } from "../../../../../shared/utils/system/filterSnackById";
import { SnackBarProgressMode } from "../../../../../shared/enums/snack-bar";
var createNotificationSlice = function (set, get, _api) { return ({
    snackBarItems: [],
    setNewSnack: function (status, message) {
        if (get().snackBarItems.length > 4) {
            set(function () { return ({
                snackBarItems: __spreadArray(__spreadArray([], get().snackBarItems.slice(1).slice(-5), true), [
                    {
                        message: message,
                        status: status,
                        progressMode: SnackBarProgressMode.LINE,
                        id: get().snackBarItems.at(-1) ? get().snackBarItems.at(-1).id + 1 : 0,
                    },
                ], false),
            }); });
            return;
        }
        set(function () { return ({
            snackBarItems: __spreadArray(__spreadArray([], get().snackBarItems, true), [
                {
                    message: message,
                    status: status,
                    progressMode: SnackBarProgressMode.LINE,
                    id: get().snackBarItems.at(-1) ? get().snackBarItems.at(-1).id + 1 : 0,
                },
            ], false),
        }); });
    },
    closeSnack: function (item) {
        set(function () { return ({ snackBarItems: filterSnackById(get().snackBarItems, item.id) }); });
    },
}); };
export default createNotificationSlice;
